import type { StorageAdapter } from '../types'

/** In-memory adapter for tests and fallback when IndexedDB is unavailable. */
export function createMemoryAdapter(initial?: Map<string, unknown>): StorageAdapter {
  const store = initial ? new Map(initial) : new Map<string, unknown>()

  return {
    async get<T>(key: string): Promise<T | null> {
      if (!store.has(key)) return null
      return store.get(key) as T
    },

    async set<T>(key: string, value: T): Promise<void> {
      store.set(key, value)
    },

    async delete(key: string): Promise<void> {
      store.delete(key)
    },

    async listKeys(prefix?: string): Promise<string[]> {
      const keys = Array.from(store.keys())
      if (!prefix) return keys
      return keys.filter((key) => key.startsWith(prefix))
    },

    async clear(): Promise<void> {
      store.clear()
    },
  }
}
